import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Field, FormError, FormSuccess } from "@/components/FormField";
import { t } from "@/lib/i18n";

const Wrap = ({ title, intro, children, testId }) => (
  <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16" data-testid={testId}>
    <div className="max-w-md">
      <h1 className="text-4xl sm:text-5xl">{title}</h1>
      {intro && <p className="mt-4 text-ink-500">{intro}</p>}
      <div className="mt-10">{children}</div>
    </div>
  </div>
);

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) { setError(apiError(err)); }
  };
  return (
    <Wrap title={t("auth.forgotTitle")} intro={t("auth.forgotIntro")} testId="forgot-password-page">
      <form onSubmit={submit} noValidate data-testid="forgot-form">
        <FormSuccess message={done} />
        <FormError message={error} />
        {!done && (
          <>
            <Field label={t("auth.email")} required>
              {(p) => <input {...p} type="email" className="input" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />}
            </Field>
            <button type="submit" className="btn-primary w-full" data-testid="forgot-submit">{t("auth.sendReset")}</button>
          </>
        )}
        <p className="mt-6"><Link to="/sign-in" className="link">{t("auth.signIn")}</Link></p>
      </form>
    </Wrap>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) { setError(apiError(err)); }
  };
  return (
    <Wrap title={t("auth.resetTitle")} testId="reset-password-page">
      {done ? (
        <div className="surface p-6 confirm-pop" role="status" data-testid="reset-success">
          <p className="font-serif text-xl font-semibold">{t("auth.resetDone")}</p>
          <Link to="/sign-in" className="btn-primary mt-5">{t("auth.signIn")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} noValidate data-testid="reset-form">
          <FormError message={error || (!token ? "This reset link is missing its code. Please use the link from your email." : "")} />
          <Field label={t("auth.newPassword")} required help={t("auth.passwordHelp")}>
            {(p) => <input {...p} type="password" className="input" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />}
          </Field>
          <button type="submit" className="btn-primary w-full" disabled={!token} data-testid="reset-submit">{t("auth.setPassword")}</button>
        </form>
      )}
    </Wrap>
  );
}
